export enum SliceStatus {
  IDLE,
  LOADING,
  FAILED,
}
